export default __webpack_public_path__ + "static/media/marked-all.f791d79c.svg";